export default __webpack_public_path__ + "static/media/Related Party Transaction Policy.f4d32383.pdf";